import React from 'react'
import { LuChevronDown } from 'react-icons/lu'
import { accessLabel, accessOf } from './teamActions'

const AccessCell = ({ row, isOpen, onOpen }) => {
  const label = accessLabel(accessOf(row))

  if (!row?.canChangeAccess) {
    return (
      <div className="flex flex-col">
        <span>{label}</span>
        <span className="text-xs text-text-secondary">Ask VLG</span>
      </div>
    )
  }

  return (
    <button
      type="button"
      aria-label={`Change access of ${row?.firstName} ${row?.lastName}`}
      className="flex items-center gap-1 cursor-pointer"
      onClick={onOpen}
    >
      <span>{label}</span>
      <LuChevronDown size={14} className={isOpen ? 'rotate-180' : ''} />
    </button>
  )
}

export default AccessCell
